<template>
  <el-dialog
        :title="$t('settlement.PaymentDetails')"
        :visible="visible"
        width="70%"
        top="5vh"
        append-to-body
        @close="handleClose"
    >
    <!-- 明细表格 -->
    <el-table :data="tableData" style="width: 100%" v-loading="loading" border height="50vh">
      <el-table-column prop="tsdTsId" :label="$t('settlement.tsId')" width="180" />
      <el-table-column prop="tsdSettType" :label="$t('settlement.tsdSettType')" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.tsdSettType === 1">{{$t('settlement.tsdSettType1')}}</span>
          <span v-else-if="scope.row.tsdSettType === 2">{{$t('settlement.tsdSettType2')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="gwNoName" :label="$t('settlement.tsdGwNo')" width="180" />
      <el-table-column prop="tsdCurrency" :label="$t('settlement.tsdCurrency')" width="180" />
      <el-table-column prop="tsdSettCurrency" :label="$t('settlement.tsdSettCurrency')" width="180" />
      <el-table-column prop="tsdTradeCount" :label="$t('settlement.tsdTradeCount')" width="180" />
      <el-table-column prop="tsdTradeFailCount" :label="$t('settlement.tsdTradeFailCount')" width="180" />
      <el-table-column prop="tsdRefundmentCount" :label="$t('settlement.tsdRefundmentCount')" width="180" />
      <el-table-column prop="tsdProtestCount" :label="$t('settlement.tsdProtestCount')" width="180" />
      <el-table-column prop="tsdCongealCount" :label="$t('settlement.tsdCongealCount')" width="180" />
      <el-table-column prop="tsdExplainCount" :label="$t('settlement.tsdExplainCount')" width="180" />
      <el-table-column prop="tsdTradeAmount" :label="$t('settlement.tsdTradeAmount')" width="180" />
      <el-table-column prop="tsdRefundmentAmount" :label="$t('settlement.tsdRefundmentAmount')" width="180" />
      <el-table-column prop="tsdProtestAmount" :label="$t('settlement.tsdProtestAmount')" width="180" />
      <el-table-column prop="tsdCongealAmount" :label="$t('settlement.tsdCongealAmount')" width="180" />
      <el-table-column prop="tsdExplainAmount" :label="$t('settlement.tsdExplainAmount')" width="180" />
      <el-table-column prop="tsdTraderate" :label="$t('settlement.tsdTraderate')" width="180" />
      <el-table-column :label="$t('settlement.tsdSppAmount')" width="180">
        <template #default="scope">
          <span>{{ scope.row.tsdSppCurrency }} {{ scope.row.tsdSppAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tsdBailrate" :label="$t('settlement.tsdBailrate')" width="180" />
      <el-table-column prop="tsdReserverAmount" :label="$t('settlement.tsdReserverAmount')" width="180" />
      <el-table-column prop="tsdFeeAmount" :label="$t('settlement.tsdFeeAmount')" width="180" />
      <el-table-column prop="tsdSppAmounts" :label="$t('settlement.tsdSppAmounts')" width="180" />
      <el-table-column prop="tsdTradeTotal" :label="$t('settlement.tsdTradeTotal')" width="180" />
      <el-table-column prop="tsdSettTotal" :label="$t('settlement.tsdSettTotal')" width="180" />
    </el-table>

    <!-- 独立的分页器 -->
    <div style="margin-top: 15px; display: flex; justify-content: flex-end;">
      <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.limit"
          :total="pagination.total"
          :page-sizes="[10, 20, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TransferFundsDetail',
  // 2. 定义 Props
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      // 3. 定义组件内部状态
      loading: false,
      tableData: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      }
    };
  },
  methods: {
    // 4. 定义方法
    async fetchData() {
      if (!this.rowId) return;
      this.loading = true;
      try {
        const res = await this.$axios.post('/api/settlement/transferFunds', {
          id: this.rowId,
          page: this.pagination.page,
          limit: this.pagination.limit
        });

        if (res.data.code === 0) {
          const responseData = res.data.data;
          this.tableData = res.data.data.records || [];
          this.pagination.total = Number(res.data.data.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询明细失败:', err);
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      // 关闭时，通过 update:visible 事件通知父组件
      this.$emit('close');
      this.tableData = [];
      this.pagination.total = 0;
    },
    handleSizeChange(newLimit) {
      this.pagination.limit = newLimit;
      this.fetchData();
    },
    handleCurrentChange(newPage) {
      this.pagination.page = newPage;
      this.fetchData();
    }
  },
  watch: {
    // 5. 监听 props 变化
    visible(newVal) {
      if (newVal) {
        this.pagination.page = 1; // 每次打开强制回到第一页
        this.fetchData();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/view/transactionSettlement/PaymentDetails.vue